import BurgerIngredient from '../BurgerIngredient/BurgIngre';
import React from 'react';
import classes from './Burger.css';

const Burger = (props) => {
    let list = props.ingredients;

    let transformedIngredients = Object.keys(list)
        .map(ingredient => {

            if (list[ingredient] <= 0) {
                list[ingredient] = 0;
                return [];
            }
            return [...Array(list[ingredient])].map((_, i) => {

                return <BurgerIngredient key={ingredient+i} type={ingredient}/>
            })
        }).reduce((arr, ele) => { return arr.concat(ele) });

    if (!transformedIngredients.length) {
        transformedIngredients = <p className={classes.Paragraph}>Please start adding ingredients</p>;
    }



    return (
        <div className={classes.Burger}>
			<BurgerIngredient type='bread-top'/>
			{transformedIngredients}
			<BurgerIngredient type='bread-bottom'/>
			</div>
    )
}

export default Burger;



// WEBPACK FOOTER //
// ./src/components/Burger/Burger.jsx